// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * The parts of the skill browse card keyed off its kind.
 *
 * The layout itself is ../catalog/CatalogBrowseLayout.module.css, shared with
 * the other browse pages. One key, as the scenario cards have: every skill
 * card wears the same strip, the top bar's own dark, so a skill reads as the
 * agents' instructions and never as an agent of some category.
 */

.vao10Jdd__tX6a08LRgz { background: var(--curio-top-bar-bg); }

/* Declared here so \`.cardActive.card_skill\` is a valid compound selector
   within this module; the shared \`.cardActive\` sets the same raised shadow. */
.X7y2Ok01iMtleUD0j6Iv { box-shadow: var(--curio-shadow-browse-card-raised); }

.X7y2Ok01iMtleUD0j6Iv.r6774bAD9kOJsmfTyEGl { border-color: var(--curio-top-bar-bg); }
`, "",{"version":3,"sources":["webpack://./src/pages/skills/SkillCatalogBrowseCard.module.css"],"names":[],"mappings":"AAAA;;;;;;;EAOE;;AAEF,wBAAe,mCAAmC,EAAE;;AAEpD;8EAC8E;AAC9E,wBAAc,kDAAkD,EAAE;;AAElE,6CAAyB,qCAAqC,EAAE","sourcesContent":["/*\n * The parts of the skill browse card keyed off its kind.\n *\n * The layout itself is ../catalog/CatalogBrowseLayout.module.css, shared with\n * the other browse pages. One key, as the scenario cards have: every skill\n * card wears the same strip, the top bar's own dark, so a skill reads as the\n * agents' instructions and never as an agent of some category.\n */\n\n.strip_skill { background: var(--curio-top-bar-bg); }\n\n/* Declared here so `.cardActive.card_skill` is a valid compound selector\n   within this module; the shared `.cardActive` sets the same raised shadow. */\n.cardActive { box-shadow: var(--curio-shadow-browse-card-raised); }\n\n.cardActive.card_skill { border-color: var(--curio-top-bar-bg); }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"strip_skill": `vao10Jdd__tX6a08LRgz`,
	"cardActive": `X7y2Ok01iMtleUD0j6Iv`,
	"card_skill": `r6774bAD9kOJsmfTyEGl`
};
export default ___CSS_LOADER_EXPORT___;
